
import React from 'react'
import { AccordionContainer } from '../../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../../common/components/form/form.module'

export default function PinCodeBasicInfoComponent ({handleInnerFormChange,selectPinCode}: any) {
  return (
    <>
 <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
<InputContainer

            label="Code"
            name="Code"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'Code'
              )
            }}
            type="text"
            value={selectPinCode?.Code}
        />
      </div>
   
  }
    expandedPanel="basicInfo"
    headerTitle="Basic Information"
/>
    
        </>
  )
}